import translateLuggageCount from '@/utils/translateLuggageCount';


export default class LuggageCounter {
  luggage20InchCount: number = 0;
  luggage25InchCount: number = 0;
  luggage27InchCount: number = 0;
  luggage29InchCount: number = 0;

  get totalLuggageCount(): number {
    return (
      this.luggage20InchCount +
      this.luggage25InchCount +
      this.luggage27InchCount +
      this.luggage29InchCount
    );
  }

  formatLuggageCount(t: (key: string, options?: any) => string): string {
    return translateLuggageCount(
      {
        luggage20InchCount: this.luggage20InchCount,
        luggage25InchCount: this.luggage25InchCount,
        luggage27InchCount: this.luggage27InchCount,
        luggage29InchCount: this.luggage29InchCount,
      },
      t,
    );
  }

  get isEmpty(): boolean {
    return this.totalLuggageCount === 0;
  }

  constructor(data: Partial<LuggageCounter> = {}) {
    Object.assign(this, data);
  }

  clone(): LuggageCounter {
    return new LuggageCounter(this);
  }
}